import { render, staticRenderFns } from "./PlaceMarker.vue?vue&type=template&id=460f4969&scoped=true&"
import script from "./PlaceMarker.vue?vue&type=script&lang=js&"
export * from "./PlaceMarker.vue?vue&type=script&lang=js&"
import style0 from "./PlaceMarker.vue?vue&type=style&index=0&id=460f4969&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460f4969",
  null
  
)

export default component.exports